import { GameBackgroundProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameBackgroundProperties";
/**
 * BackgroundPortraitProperties.ts
 */
export class BackgroundPortraitProperties extends GameBackgroundProperties {
    constructor() {
        super();
        this.position.set(512, 973);
        this.borderProperties.position.set(0, -2);
    }
}
//# sourceMappingURL=BackgroundPortraitProperties.js.map